if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.content = this.querySelector('[role="document"]');
      this.previous = this.querySelector('[data-lightbox-prev]');
      this.next = this.querySelector('[data-lightbox-next]');
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.addEventListener('keydown', (event) => {
        if (!this.hasAttribute('open')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      this.content.addEventListener('click', (event) => {
        if (event.target === this.content || event.target.matches('img[data-media-id]')) this.hide();
      });
    }
    show(opener) {
      super.show(opener);
      this.items = Array.from(this.content.children).filter(item => item.hasAttribute('data-media-id'));
      const index = this.items.findIndex(item => item.dataset.mediaId === opener.dataset.mediaId);
      this.activate(index < 0 ? 0 : index);
    }
    move(step) {
      if (!this.items || this.items.length < 2) return;
      this.activate((this.index + step + this.items.length) % this.items.length);
    }
    activate(index) {
      if (!this.items.length) return;
      window.pauseAllMedia();
      this.index = index;
      this.items.forEach((item, i) => {
        item.classList.toggle('active', i === index);
        item.hidden = i !== index;
        item.inert = i !== index;
      });
      this.previous.disabled = this.next.disabled = this.items.length < 2;
      this.querySelector('[data-lightbox-current]').textContent = String(index + 1);
      this.querySelector('[data-lightbox-total]').textContent = String(this.items.length);
      const active = this.items[index];
      if (active.tagName === 'DEFERRED-MEDIA') active.loadContent(false);
    }
  });
}
